export default "__VITE_ASSET__e2905bf9__"